import { makeRequest, REQUEST_TYPE } from "./request";
import { KOR_API_PRIVATE } from "../entry";

KOR_API_PRIVATE.jsonLatexSiniat = async (props) =>
  makeRequest(props, "json/latex/siniat", REQUEST_TYPE.POST_JSON);
